import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import classNames from 'classnames';
import React, {FC, ReactNode, useEffect, useState} from 'react';
import style from './style.module.scss';

// eslint-disable-next-line no-shadow
export enum FilterCheckboxHeightType {
    Default = 'default',
    Height34 = 'height34',
}

export interface IProps {
    code: string;
    count?: number;
    height?: FilterCheckboxHeightType;
    isDefaultChecked: boolean;
    onChange: (code: string, isChecked: boolean) => void;
    title: string;
    description?: ReactNode;
    className?: string;
}

export const FilterCheckbox: FC<IProps> = ({
    code,
    count,
    height,
    isDefaultChecked,
    onChange,
    title,
    description,
    className,
}) => {
    const [currentIsDefaultChecked, setCurrentIsDefaultChecked] = useState(isDefaultChecked);
    const [isChecked, setIsChecked] = useState(isDefaultChecked);

    useEffect(() => {
        if (currentIsDefaultChecked === isDefaultChecked) {
            return;
        }

        setCurrentIsDefaultChecked(isDefaultChecked);
        setIsChecked(isDefaultChecked);
    }, [currentIsDefaultChecked, isDefaultChecked]);

    const handleChange = () => {
        const value = !isChecked;

        setIsChecked(value);
        onChange(code, value);
    };

    return (
        <label
            className={classNames(
                style.main,
                {[style.isChecked]: isChecked, ...(height ? {[style[height]]: height} : {})},
                className,
            )}
        >
            <input
                data-skeleton-item={true}
                checked={isChecked}
                className={style.checkbox}
                onChange={handleChange}
                type={'checkbox'}
            />
            <span data-skeleton-item={true} className={style.checkmark}>
                <Icon className={style.icon} icon={'checkmark'} />
            </span>
            <div data-skeleton-item={true} className={style.content}>
                <Typography variant={'label-14-r'}>{title}</Typography>
                {description}
            </div>
            <Typography data-skeleton-item={true} className={style.count} variant={'label-14-r'}>
                {count}
            </Typography>
        </label>
    );
};
